"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIMEOUT = 10000;
exports.fetchWithTimeout = function (requestInfo, requestInit, timeout) {
    if (timeout === void 0) { timeout = exports.DEFAULT_TIMEOUT; }
    return Promise.race([
        fetch(requestInfo, requestInit),
        new Promise(function (_resolve, reject) {
            return setTimeout(function () { return reject(new Error('timeout')); }, timeout);
        }),
    ]);
};
//# sourceMappingURL=FetchWithTimeout.js.map